import { useMutation } from "@tanstack/react-query";
import { useNotificationsInvalidate } from "PFCore/hooks/queries/notifications/use_notifications_invalidate";
import {
  markNotificationsAsRead,
  MarkNotificationsPayload
} from "PFCore/services/notifications/mark_notifications_as_read";
import { MutationOptions } from "PFTypes/request_options";

export const useNotificationsMarkAsRead = ({
  onSuccess,
  ...options
}: MutationOptions<MarkNotificationsPayload> = {}) => {
  const { invalidate: invalidateNotifications } = useNotificationsInvalidate();

  return useMutation({
    mutationFn: (payload: MarkNotificationsPayload) => markNotificationsAsRead(payload),
    onSuccess: (...params) => {
      invalidateNotifications();
      onSuccess?.(...params);
    },
    ...options
  });
};
